import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import InputWrapper from './InputWrapper';
import RadioButton from './RadioButton';
import SelectField from './SelectField';
import SwtichButton from './SwitchButton';
import TextField from './TextField';
import { FormProps } from './form.interface';
import * as S from './form.styles';

const Form = ({ onSubmit, children, id, className }: FormProps) => (
  <S.Form onSubmit={onSubmit} id={id} className={className} autoComplete="off">
    {children}
  </S.Form>
);

export default Form;
export { Checkbox, DatePicker, InputWrapper, RadioButton, SelectField, SwtichButton, TextField };
